import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {CoreDI, IBrowser, inject, LanguageService} from '@gongxigames/framework/core';
import {ResourceManager} from '@gongxigames/framework/slot/services/ResourcesManager';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {PickBonusEvents} from '@gongxigames/framework/slot/modules/pick';
import {SelectBonusEvents} from '@gongxigames/framework/slot/modules/selectBonus';
import {BuyBonusPopUpEvents} from '@gongxigames/framework/slot/modules/buyBonus';
import {NetworkErrors} from '@gongxigames/framework/slot';

export class NetworkModule extends Module<null> {
    public static readonly NAME: symbol = Symbol.for('NetworkModule');
    public static readonly BASIC_STATE: string = 'basic';

    @inject(CoreDI.Browser)
    protected _browser!: IBrowser;

    @inject(CoreDI.LanguageService)
    protected _language!: LanguageService;

    @inject(DI.ResourceManager)
    protected _resourceManager!: ResourceManager;

    protected _internetConnectionLost = false;
    protected onlineListener: () => void = this.onOnline.bind(this);
    protected offlineListener: () => void = this.onOffline.bind(this);

    public destroy(): void {
        super.destroy();

        this._browser.removeEventListener('online', this.onlineListener);
        this._browser.removeEventListener('offline', this.offlineListener);
    }

    protected setupEvents(): void {
        this.on(ReelsEvents.REELS_SPINNING_STARTED, this.requestAction);
        this.on(ReelsEvents.REELS_RESPINNING_STARTED, this.requestAction);
        this.on(PickBonusEvents.PICK, this.onBonusGamePick);
        this.on(SelectBonusEvents.SELECT, this.onSelectBonusGame);
        this.on(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuy);
        this.on('General.BuyFeature.BUY', this.onBuyFeature);

        this._browser.addEventListener('online', this.onlineListener);
        this._browser.addEventListener('offline', this.offlineListener);
    }

    protected onOnline(): void {
        if (this._resourceManager.isResourcesLoaded) {
            if (this._internetConnectionLost) {
                this.eventManager.emit('General.Network.CLOSE_ERROR', NetworkErrors.LOST_CONNECTION);
                this._internetConnectionLost = false;
            }
        }
    }

    protected onOffline(): void {
        if (this._resourceManager.isResourcesLoaded) {
            if (!this._internetConnectionLost) {
                this.eventManager.emit('General.Network.SHOW_ERROR', NetworkErrors.LOST_CONNECTION);
                this._internetConnectionLost = true;
            }
        }
    }

    protected onBonusGamePick(eventID: string | symbol, index: number): void {
        this.logic.pick(null as any, index);
    }

    protected onSelectBonusGame(eventID: string | symbol, index: number): void {
        this.logic.select(null as any, index);
    }

    protected onBuy(eventID: string | symbol): void {
        this.logic.buy(null as any);
    }

    protected onBuyFeature(eventID: string | symbol): void {
        this.logic.buyFeature(null as any);
    }

    protected onGetJackpotProgressive(): void {
        this.logic.progressiveValues(null as any);
    }

    protected requestAction(): void {
        if (!this.logic.isAvailableNextAction()) {
            return;
        }

        switch (this.logic.nextAction) {
            case Action.SPIN: {
                this.logic.spin(null as any);
                break;
            }

            case Action.FREESPIN: {
                this.logic.freespin(null as any);
                break;
            }

            case Action.RESPIN: {
                this.logic.respin(null as any);
                break;
            }

            // @ts-ignore: TODO: refactor
            case Action.MINISPIN: {
                this.logic.minispin(null as any);
                break;
            }

            default:
                break;
        }
    }

    protected setupViews(): void {
    }

    protected setupStates(): void {
    }
}
